import { ICreateDraftJobResult } from '../types';
import { DraftJobPostAdapters } from '../adapters';
import { PermanentJobsApi } from '../clients';

export const createDraftJobPost = async (): Promise<ICreateDraftJobResult> => {
  const response = await PermanentJobsApi.createDraftJobPost();

  return DraftJobPostAdapters.toCreateDraftJobPostResult(response);
};
